// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1ruBs","containerItemsCenter":"Skeleton_containerItemsCenter__ZU78I"};